import { useSelector } from 'react-redux'
import { isLoaded, useFirestoreConnect } from 'react-redux-firebase'
import naturalSort from 'javascript-natural-sort'
import type { Company } from 'types/company'
import type { RootState } from 'state/store.types'

export const useSelectedManagerCompanies = () => {
	const uid = useSelector((state: RootState) => state.firebaseReducer.auth?.uid)
	const selectedManagerUUID =
		useSelector((state: RootState) => state.app.selectedManagerUUID) ||
		'empty-value'

	useFirestoreConnect(
		uid && selectedManagerUUID
			? [
					{
						collection: 'company',
						storeAs: `managerCompanies_${selectedManagerUUID}`,
						where: [['managerUUID', '==', selectedManagerUUID]],
					},
			  ]
			: [],
	)

	return useSelector(({ firestoreReducer }: any) => {
		const companies = firestoreReducer.ordered[
			`managerCompanies_${selectedManagerUUID}`
		] as Company[]

		if (!uid || !selectedManagerUUID) {
			console.error('Company not selected or no auth uid.')
			return { loading: false, selectedManagerCompanies: [] }
		}

		if (!isLoaded(companies)) {
			return { loading: true, selectedManagerCompanies: [] }
		}

		const sortedCompanies =
			Array.isArray(companies) && companies.length > 0
				? [...companies].sort((a, b) => naturalSort(a.name, b.name))
				: []

		return {
			loading: false,
			selectedManagerCompanies: sortedCompanies,
		}
	})
}
